<div [class.border]="renderInCard === true" class="rounded bg-white" [class.email-wrapper]="noSpacing === false">
  <div class="row g-0 justify-content-center">


    <!-- END FILTER PART -->
    <div class="col-lg-12">
      <div class="email-right-column" [class.p-4]="noSpacing === false" [class.p-xl-5]="noSpacing === false">
        <!-- Email Right Header -->
        @if (displaySearch || importantItemFilterTemplate || listActionsTemplate) {
          <div class="email-right-header" >
            <!-- head left option -->
            <form [formGroup]="form">
              <div class="head-left-options">
                @if (displaySearch) {
                  <div class="form-group mg-b-0">
                    <div class="input-group">
                      
                        <span class="input-group-text bd-t-0 bd-l-0"><i class="fas fa-search"></i> </span>
                      
                      <input formControlName="SearchText" (keydown.enter)="updateFilter($event)" type="text"
                        style="background-color: #f5f6fa;" class="form-control bd-t-0 bd-r-0 bd-l-0"
                        placeholder="{{'T4.LIST-VIEW.SEARCHINLIST' | translate}}">
                      </div>
                    </div>
                  }
                  @if (importantItemFilterTemplate) {
                    <div>
                      <ng-container *ngTemplateOutlet="importantItemFilterTemplate; context: importantFilterValues">
                      </ng-container>
                    </div>
                  }
                </div>
              </form>
              <!-- head right option -->
              <div class="head-right-options">
                <ng-container *ngTemplateOutlet="listActionsTemplate">
                </ng-container>
              </div>
            </div>
          }

          @if (itemFilterTemplate) {
            <div class="listview-filter">
              <ng-container *ngTemplateOutlet="itemFilterTemplate; context: filterValues">
              </ng-container>
              @if (displayAIOptions) {
                <div class="advanced">
                  <button (click)="showAdvanced = !showAdvanced" class="text-muted" type="button">
                    <i class="fas fa-filter ps-1 pe-2"></i>  {{ 'T4.LIST-VIEW.AI-OPTIONS.TOGGLE' | translate }}
                  </button>
                  @if (showAdvanced) {
                    <div class="advanced-panel ps-2" style="margin-top: 10px;">
                      <div class="form-group" style="display: flex; gap: 20px; align-items: center; margin-bottom: 0;">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="searchMode" id="searchModeAll" value="all" [(ngModel)]="searchMode">
                          <label class="form-check-label" for="searchModeAll">
                            {{ 'T4.LIST-VIEW.AI-OPTIONS.SEARCH-MODE.ALL' | translate }}
                          </label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="searchMode" id="searchModeAny" value="any" [(ngModel)]="searchMode">
                          <label class="form-check-label" for="searchModeAny">
                            {{ 'T4.LIST-VIEW.AI-OPTIONS.SEARCH-MODE.ANY' | translate }}
                          </label>
                        </div>
                      </div>
                      <div class="pro-tip" style="margin-top: 10px; padding: 10px; background-color: #e7f3ff; border-left: 3px solid #2196F3; border-radius: 3px; color: #000;">
                        <strong>{{ 'T4.LIST-VIEW.AI-OPTIONS.PRO-TIP.TITLE' | translate }}:</strong> <span>{{ 'T4.LIST-VIEW.AI-OPTIONS.PRO-TIP.TEXT' | translate }}</span>
                      </div>
                    </div>
                  }
                </div>
              }
              <div class="row">
                <div class="col-lg-12" style="padding: 10px 20px 0px 0px;">
                  <div class="row">
                    <div class="col-lg-4 text-start ps-6">
                      @if (showBarcodeButton) {
                        <button class="btn btn-secondary border btn-small" type="button" (click)="customerPickupBarcode()">
                          <i class="fas fa-barcode"></i>
                          <span>{{ 'BTN.SEARCH.BARCODE' | translate }}</span>
                        </button>
                      }
                    </div>
                    @if (showFilterActionButtons) {
                      <div class="col-lg-8 text-end">
                        <button (click)="clearFilter($event)"  class="btn btn-warning border btn-small me-1" type="button"><i class="fas fa-undo"></i>{{'GENERIC.BUTTON.EMPTY' | translate}}</button>
                        <button (click)="updateFilter($event)" class="btn btn-primary border btn-small" type="button"><i class="fas fa-search"></i>{{'BTN.APPLY' | translate}}</button>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }

          @if (listBannerTemplate) {
            <ng-container *ngTemplateOutlet="listBannerTemplate"></ng-container>
          }

          @if (displayFacets) {
            <div>
              <t4-list-view-facets [facets]="searchFacets" #facetsComponent (onSelect)="facetSelectionChanged($event)"></t4-list-view-facets>
            </div>
          }

          <div class=" border-top-0 rounded table-responsive" [style.overflow]="fixedTableLayout ? 'auto':'inherit'">
            <table class="table mb-0 table-hover table-email" [class.table-shrink]="listStyle === 'shrink'" [style.tableLayout]="fixedTableLayout ? 'fixed':'inherit'">

              <thead>

                <tr class="list-head">
                  @if (expandableRows) {
                    <th scope="col" style="width:32px;"></th>
                  }
                  @if (hasSelectionColumn()) {
                    <th scope="col" style="width:26px; vertical-align: middle;"></th>
                  }
                  @for (h of listHeaders; track h) {
                    @if (isVisible(h)) {
                      <th scope="col" [class]="getHeaderClasses(h)" [attr.colspan]='getColSpan(h)'
                        [style.width]='getWidth(h)' [style.overflow]="h.overflowHidden ? 'hidden':'inherit'">
                        <span [class.clickable]="h.sortField !== null && !disableSort" (click)="sort(h)">{{h.label | translate}}</span>
                        @if (sortField === h.sortField && sortAsc === true && !disableSort) {
                          <i class="sort-by-asc"></i>
                        }
                        @if (sortField === h.sortField && sortAsc === false && !disableSort) {
                          <i class="sort-by-desc"></i>
                        }
                      </th>
                    }
                  }
                </tr>

              </thead>

              <tbody>

                <ng-container *ngTemplateOutlet="customContentTemplate;"></ng-container>
                @if (dataItems !== null && dataItems !== undefined && dataItems.length > 0) {
                  <ng-container *ngTemplateOutlet="additionalItemTemplate;"></ng-container>
                  @for (item of dataItems; track item; let odd = $odd) {
                    <tr [class]="getRowClasses(item, odd)" class="text-dark" (click)="doRowClick($event, item)" data-testid="list-row">
                      @if (expandableRows) {
                        <td class="list-view__expand-chevron">
                          @if (!expandableDataField || item[expandableDataField]?.length > 0) {
                            <i
                            class="fas" [class.fa-chevron-down]="isExpanded(item)" [class.fa-chevron-right]="!isExpanded(item)"></i>
                          }
                        </td>
                      }
                      @if (hasSelectionColumn()) {
                        <td style="width:26px;">
                          <div style="padding-top: 4px;">
                            <input type="checkbox" [checked]="isSelected(item)">
                          </div>
                        </td>
                      }
                      <ng-container *ngTemplateOutlet="listItemTemplate; context: {$implicit: item}"></ng-container>
                    </tr>
                    @if (expandableRows && isExpanded(item)) {
                      <tr class="expand-row">
                        <td [attr.colspan]="getExpandColspan()" style="padding: 0;">
                          <ng-container *ngTemplateOutlet="listItemExpandTemplate || generatedExpandTemplate; context: {$implicit: item}"></ng-container>
                          <ng-template #generatedExpandTemplate let-item>
                            @if (expandableDataField && item[expandableDataField]?.length) {
                              <div class="list-view__expand-details">
                                <div class="list-view__expand-grid">
                                  @if (expandableHeaders.length > 0) {
                                    <div class="list-view__expand-header-row" [ngClass]="getExpandableGridColumnClass()">
                                      @for (h of expandableHeaders; track h) {
                                        <div class="list-view__expand-header-cell">{{ h.label | translate }}</div>
                                      }
                                    </div>
                                  }
                                  @for (subItem of item[expandableDataField]; track subItem) {
                                    <div class="list-view__expand-change-row" [ngClass]="getExpandableGridColumnClass()">
                                      @for (h of expandableHeaders; track h) {
                                        <div [class]="getExpandableCellClasses(h.className)">
                                          {{ subItem[h.field] ?? '-' }}
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </ng-template>
                        </td>
                      </tr>
                    }
                  }
                } @else {
                  <tr>
                    @if (searchPerformed === true) {
                      <td [attr.colspan]="getMainRowColspan()" [innerHTML]="noItemText | translate"></td>
                    }
                    @if (searchPerformed === false) {
                      <td [attr.colspan]="getMainRowColspan()" [innerHTML]="'LISTVIEW.STARTSEARCH' | translate"></td>
                    }
                  </tr>
                }


              </tbody>
            </table>
          </div>



          <t4-pager [pageSize]="pageSize" [listCounts]="listCounts" [selectCount]="null"
          (onPage)="doPage($event)" [resultsCapped]="resultsCapped" #pagerComponent></t4-pager>

        </div>
      </div>
    </div>
  </div>
